<template>
  <!-- 百草元和 - 我的积分页面 -->
  <div>
    <div class="sub-container">
      <el-page-header class="page-header" @back="goBack" content="我的积分"></el-page-header>

      <!-- 积分概览卡片 -->
      <div class="points-overview-card">
        <div class="overview-left">
          <div class="overview-label">当前可用积分</div>
          <div class="overview-value">{{ account.availablePoints || 0 }}</div>
          <div class="overview-meta">
            <span class="meta-item">累计获得 {{ account.totalEarnedPoints || 0 }}</span>
            <span class="meta-divider">|</span>
            <span class="meta-item">累计兑换 {{ account.totalExchangePoints || 0 }}</span>
          </div>
        </div>
        <div class="overview-right">
          <div class="register-date">注册日期：{{ formatDate(account.registerDate) || '—' }}</div>
          <div class="next-clear-tip">积分按自然年滚动清零</div>
        </div>
      </div>

      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" class="points-tabs">
        <el-tab-pane label="变动明细" name="changeLog">
          <el-table :data="changeLogList" style="width: 100%" v-loading="changeLoading" :border="false">
            <el-table-column prop="changeTime" label="变动时间" min-width="160"></el-table-column>
            <el-table-column label="变动类型" min-width="100">
              <template slot-scope="scope">
                <el-tag :type="getTypeTag(scope.row.changeType)" size="small">{{ formatType(scope.row.changeType) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="变动积分" min-width="100" align="right">
              <template slot-scope="scope">
                <span :style="{ color: scope.row.points >= 0 ? '#009798' : '#F56C6C', fontWeight: 'bold' }">
                  {{ scope.row.points >= 0 ? '+' : '' }}{{ scope.row.points }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="pointsAfter" label="变动后积分" min-width="100" align="right"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
          </el-table>
          <el-pagination v-if="changeTotal > 10" class="pagination" background layout="prev, pager, next"
                        :current-page="changeQuery.pageNum" @current-change="changePageChange"
                        :total="changeTotal"></el-pagination>
        </el-tab-pane>

        <el-tab-pane label="兑换明细" name="exchange">
          <el-table :data="exchangeList" style="width: 100%" v-loading="exchangeLoading" :border="false">
            <el-table-column prop="exchangeTime" label="兑换日期" min-width="160"></el-table-column>
            <el-table-column prop="exchangeNo" label="兑换单号" min-width="180"></el-table-column>
            <el-table-column prop="exchangeItem" label="兑换事项" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="兑换积分" min-width="100" align="right">
              <template slot-scope="scope">
                <span style="color: #F56C6C; font-weight: bold;">-{{ scope.row.exchangePoints }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="operatorName" label="操作人" min-width="100"></el-table-column>
            <el-table-column label="状态" min-width="80">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
                  {{ scope.row.status === 1 ? '正常' : '已撤销' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
          </el-table>
          <el-pagination v-if="exchangeTotal > 10" class="pagination" background layout="prev, pager, next"
                        :current-page="exchangeQuery.pageNum" @current-change="exchangePageChange"
                        :total="exchangeTotal"></el-pagination>
        </el-tab-pane>
      </el-tabs>

      <!-- 固定文案 -->
      <div class="points-notice">
        <div class="notice-title">温馨提示</div>
        <ul class="notice-list">
          <li>积分按机构注册日为起点，按自然年滚动清零，过期积分将自动作废。</li>
          <li>积分仅用于兑换奖品/权益，不可转让、不可提现、不可抵扣订单金额。</li>
          <li>积分规则的最终解释权归本公司所有。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPoints',
  data() {
    return {
      activeTab: 'changeLog',
      account: {},
      // 变动明细
      changeLoading: false,
      changeLogList: [],
      changeTotal: 0,
      changeQuery: { pageNum: 1, pageSize: 10 },
      // 兑换明细
      exchangeLoading: false,
      exchangeList: [],
      exchangeTotal: 0,
      exchangeQuery: { pageNum: 1, pageSize: 10 }
    }
  },
  activated() {
    this.init()
  },
  created() {
    this.init()
  },
  watch: {
    activeTab(val) {
      if (val === 'exchange' && this.exchangeList.length === 0) {
        this.getExchangeList()
      } else if (val === 'changeLog' && this.changeLogList.length === 0) {
        this.getChangeLogList()
      }
    }
  },
  methods: {
    init() {
      this.getAccountInfo()
      this.getChangeLogList()
    },
    goBack() {
      this.$router.push('/')
    },
    getAccountInfo() {
      this.wjtHttp.get(this, '/api/biz/points/info', {}, true, (res) => {
        if (res && res.data && res.data.data) {
          this.account = res.data.data
        }
      })
    },
    getChangeLogList() {
      this.changeLoading = true
      this.wjtHttp.get(this, '/api/biz/points/changeLog/list', this.changeQuery, false, (res) => {
        this.changeLoading = false
        if (res && res.data) {
          this.changeLogList = res.data.rows || []
          this.changeTotal = res.data.total || 0
        }
      })
    },
    changePageChange(p) {
      this.changeQuery.pageNum = p
      this.getChangeLogList()
    },
    getExchangeList() {
      this.exchangeLoading = true
      this.wjtHttp.get(this, '/api/biz/points/exchange/list', this.exchangeQuery, false, (res) => {
        this.exchangeLoading = false
        if (res && res.data) {
          this.exchangeList = res.data.rows || []
          this.exchangeTotal = res.data.total || 0
        }
      })
    },
    exchangePageChange(p) {
      this.exchangeQuery.pageNum = p
      this.getExchangeList()
    },
    formatType(type) {
      const m = { 1: '分账获取', 2: '积分兑换', 3: '兑换撤销', 4: '手动增加', 5: '手动扣减', 6: '年度清零' }
      return m[type] || '未知'
    },
    getTypeTag(type) {
      const m = { 1: 'success', 2: 'warning', 3: '', 4: 'success', 5: 'danger', 6: 'info' }
      return m[type] || ''
    },
    formatDate(d) {
      if (!d) return ''
      return String(d).substring(0, 10)
    }
  }
}
</script>

<style scoped>
.sub-container {
  max-width: 1100px;
  margin: 20px auto;
  padding: 0 20px;
}
.page-header {
  margin-bottom: 20px;
}
.points-overview-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #009798 0%, #007e7f 100%);
  color: #fff;
  border-radius: 12px;
  padding: 28px 32px;
  margin-bottom: 24px;
  box-shadow: 0 4px 16px rgba(0, 151, 152, 0.25);
}
.overview-label {
  font-size: 14px;
  opacity: 0.9;
}
.overview-value {
  font-size: 48px;
  font-weight: bold;
  line-height: 1.2;
  margin: 6px 0 10px;
}
.overview-meta {
  font-size: 13px;
  opacity: 0.9;
}
.meta-divider {
  margin: 0 10px;
  opacity: 0.6;
}
.overview-right {
  text-align: right;
}
.register-date {
  font-size: 13px;
  opacity: 0.9;
  margin-bottom: 6px;
}
.next-clear-tip {
  font-size: 12px;
  opacity: 0.75;
}
.points-tabs {
  margin-bottom: 24px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.points-notice {
  background: #f7f9fb;
  border-radius: 8px;
  padding: 16px 20px;
  border-left: 4px solid #009798;
}
.notice-title {
  font-size: 14px;
  font-weight: bold;
  color: #009798;
  margin-bottom: 8px;
}
.notice-list {
  margin: 0;
  padding-left: 20px;
  color: #666;
  font-size: 13px;
  line-height: 1.8;
}
</style>
